import type { PressEvent } from '@react-types/shared';
import { useCallback } from 'react';

import { CSS } from '@project44/manifest-ds';

import { scopedT } from '../../utils/functions/scopedT';
import { Banner } from '../Banner';

const t = scopedT();

interface Props {
  onLearnMore?: (event: PressEvent) => void;
  onClose?: (event: PressEvent) => void;
  css?: CSS;
}

export function CarrierWelcomeBanner({ onLearnMore, onClose, css }: Props) {
  const onButtonClick = useCallback(
    (event) => {
      window.open(
        'https://www.project44.com/blog/movement-for-carriers',
        '_blank',
        'noopener,noreferrer',
      );
      onLearnMore?.(event);
    },
    [onLearnMore],
  );

  return (
    <Banner
      title={t('carrierWelcome.title')}
      subTitle={t('carrierWelcome.subTitle')}
      icon="info"
      iconColor="$palette-purple-800"
      buttonText={t('carrierWelcome.learnMore')}
      buttonProps={{ onPress: onButtonClick }}
      onClose={onClose}
      titleCSS={{
        flex: 1,
      }}
      css={{
        backgroundColor: '$palette-purple-50',
        ...css,
      }}
    />
  );
}
